// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text, TextProps } from '@mantine/core';
import { FC } from 'react';

interface Props extends TextProps {
  onClick: () => void;
}

const LinkText: FC<Props> = ({ children, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Text
    variant="link"
    sx={(theme) => ({
      cursor: 'pointer',
      display: 'inline-block',
      color: theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.blue[4],
    })}
    {...rest}
  >
    {children}
  </Text>
);

export default LinkText;
